import React, { useMemo, useCallback } from 'react'

import { useLocalStorageContext } from '../../../../contexts/LocalStorageContext'
import { useGetOrders } from '../../../../hooks/useGetOrders'
import useSuggestions from '../../../../sdk/search/useSuggestions'
import { formatSearchedItems } from '../../../../utils/dropdownSearchFunctions'
import { SearchDropdownSection } from '../../../ui/SearchDropdownComponents'
import { SearchProductsSection } from '../../DropdownSearchProducts/SearchProductsSection'
import './main-search-dropdown.scss'

interface MainSearchDropdownProps {
  searchTerm: string
  setOpenInputDropdown: (openDropDown: boolean) => void
  setTerm: (term: string) => void
  isMobileNavbar?: boolean
  setShowMenu?: (showMenu: boolean) => void
}

export const MainSearchDropdown = ({
  searchTerm,
  setTerm,
  setOpenInputDropdown,
  isMobileNavbar,
  setShowMenu,
}: MainSearchDropdownProps) => {
  const { lastSearched, addLastSearchedItem } = useLocalStorageContext()
  const { terms: mostSearched } = useSuggestions('')
  const { terms: suggestion } = useSuggestions(searchTerm, 4)
  const { itemsOrdersTerm } = useGetOrders(searchTerm)

  const isMoreThreeCharacters = useMemo(
    () => searchTerm.split('').length >= 3,
    [searchTerm]
  )

  const mostSearchedFiltered = useMemo(
    () =>
      mostSearched?.filter((item: { value: string }) => item.value.length >= 3),
    [mostSearched]
  )

  const handleLinkction = useCallback(
    (term?: string, link?: string, updateSearchBar?: boolean) => {
      setOpenInputDropdown(false)

      if (isMobileNavbar) {
        setShowMenu?.(false)
      }

      if (updateSearchBar) {
        setTerm(term ?? '')
      }

      addLastSearchedItem?.(term ?? '', link ?? '')
    },
    []
  )

  return (
    <div className="main-search-dropdow-container">
      <div className="main-search-dropdow-content">
        {!isMoreThreeCharacters && !isMobileNavbar && (
          <SearchDropdownSection
            sectionTitle="Recentes"
            updateSearchBar
            warningText="Você ainda não realizou nenhuma busca"
            searchedItems={lastSearched}
            trigger={handleLinkction}
          />
        )}

        {!isMoreThreeCharacters && !isMobileNavbar && (
          <SearchDropdownSection
            sectionTitle="Os Mais Pesquisados"
            updateSearchBar
            searchedItems={formatSearchedItems(mostSearchedFiltered)}
            trigger={handleLinkction}
            hiddenVisibility={mostSearched.length < 1}
          />
        )}
        {isMoreThreeCharacters && itemsOrdersTerm && !isMobileNavbar && (
          <SearchDropdownSection
            sectionTitle="Comprar De Novo"
            searchedTerm={searchTerm}
            searchedItems={itemsOrdersTerm}
            trigger={handleLinkction}
            noHighlighted
          />
        )}

        {isMoreThreeCharacters && (
          <SearchDropdownSection
            sectionTitle="Sugestões"
            updateSearchBar
            warningText={isMobileNavbar ? 'Nenhuma sugestão encontrada' : ''}
            searchedTerm={searchTerm}
            trigger={handleLinkction}
            searchedItems={formatSearchedItems(suggestion, searchTerm)}
            hiddenVisibility={!isMobileNavbar && suggestion.length < 1}
          />
        )}

        {isMoreThreeCharacters && (
          <SearchProductsSection
            title={`Produtos Para “${searchTerm}”`}
            searchTerm={searchTerm}
            setOpenInputDropdown={setOpenInputDropdown}
          />
        )}
      </div>
    </div>
  )
}
